export const environment = {
    production: false,

    apiUrl: process.env["backOffice_apiUrl"],

    azureRedirectUri: process.env["backOffice_azureRedirectUri"]
};

